import { generatePath } from 'react-router-dom'
import { CAMPAIGNS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Layers5 } from 'blaze-ui/icons/24'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuCampaignsItem = ({ workspaceId, onPress }: Props) => {
  const to = generatePath(CAMPAIGNS_PATH, { workspaceId })

  return <NavMenuItem icon={Layers5} activeIcon={Layers5} to={to} onPress={onPress} label="Campaigns" />
}

export { NavMenuCampaignsItem }
